import { render, staticRenderFns } from "./spotleyHeader.vue?vue&type=template&id=3a6aa3b4&"
var script = {}
import style0 from "./spotleyHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "spotleyHeader.vue"
export default component.exports